export default (settings: any) => {
  if (settings['fileUploadColumns'] === 0) {
    return 0
  }
  return 2 + settings['fileUploadColumns'] * 0.5
}
